import React from 'react';
import bandera from '../imgs/otros/flag-42582_1280.png';
import '../styles/BanderaCuadros.css';

export default function BanderaCuadros() {

    return (
        <div className='bandera-cuadros__div--container'>
            <div className='bandera-cuadros__div'>
                <img src={bandera} alt='bandera.png'/>
            </div>
        </div>
    )
}
